"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "./theme-provider"
import { Button } from "./ui/button"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  return (
    <Button
      variant="outline"
      size="default"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="flex items-center gap-2"
    >
      {theme === "light" ? (
        <>
          <Moon className="h-5 w-5" />       
        </>
      ) : (
        <>
          <Sun className="h-5 w-5" /> 
        </>
      )}
    </Button>
  )
} 